import { API_URL } from "../config/Api_Url";

const requestJson = async (path) => {
  const response = await fetch(`${API_URL}${path}`, {
    credentials: "omit",
  });

  if (!response.ok) {
    throw new Error(`Request failed with status ${response.status}`);
  }

  return response.json();
};

const StoriesService = {
  getStories: async function () {
    return requestJson("/stories");
  },

  getStory: async function (id) {
    return requestJson(`/stories/${id}`);
  },
};

export default StoriesService;
